import { ThemeStyle } from "assets/scss/common/theme";
import styled from "@emotion/styled";


export const ToggleSwitchWrapper = styled.div`
  .switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 24px;
    border-radius: 12px;
  }
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .control__indicator {
    display: ${({ isChecked } : {isChecked: boolean}) => isChecked ? "block" : "none"};
    position: relative;
    left: 8px;
    top: 7px;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border: 1px solid ${({ theme }: ThemeStyle) => theme.lightGreyShadow};
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 1px;
    bottom: 2px;
    background-color: ${({ theme }: ThemeStyle) => theme.white};
    -webkit-transition: .4s;
    transition: .4s;
  }
  input:checked + .slider {
    background-color: ${({ theme }: ThemeStyle) => theme.brandtextPrimaryColor};
  }
  input:focus + .slider {
    box-shadow: 0 0 1px ${({ theme }: ThemeStyle) => theme.brandPrimary900};
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(14px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 12px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
`;
